export default __webpack_public_path__ + "static/media/capital_section_image_tablet.83d6dc1e.jpg";